import { render, staticRenderFns } from "./GovProgramsIntro.vue?vue&type=template&id=12e27ddd&lang=pug"
import script from "./GovProgramsIntro.vue?vue&type=script&lang=js"
export * from "./GovProgramsIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports